// extracted by mini-css-extract-plugin
export var bg_decor = "layout-module--bg_decor--af3ce";
export var brand = "layout-module--brand--3226c";
export var brand_wrapper = "layout-module--brand_wrapper--3d25d";
export var footer_center_col = "layout-module--footer_center_col--45d15";
export var footer_col = "layout-module--footer_col--1935c";
export var footer_decor = "layout-module--footer_decor--912f8";
export var footer_icon = "layout-module--footer_icon--39b81";
export var footer_icon_wrapper = "layout-module--footer_icon_wrapper--0de0a";
export var footer_info_row = "layout-module--footer_info_row--8d056";
export var footer_left_col = "layout-module--footer_left_col--5ed9b";
export var footer_left_col_content = "layout-module--footer_left_col_content--fa62c";
export var footer_links = "layout-module--footer_links--1b8b3";
export var footer_right_col = "layout-module--footer_right_col--86758";
export var footer_row = "layout-module--footer_row--46e5f";
export var footer_sponsor = "layout-module--footer_sponsor--d50a5";
export var footer_sponsor_flex = "layout-module--footer_sponsor_flex--74d6e";
export var footer_sponsor_wrapper = "layout-module--footer_sponsor_wrapper--3e45e";
export var footer_wrapper = "layout-module--footer_wrapper--49cbd";
export var hamburger_btn = "layout-module--hamburger_btn--71c3a";
export var navbar_collapse = "layout-module--navbar_collapse--8e0b3";
export var navbar_icon = "layout-module--navbar_icon--f39e8";
export var navbar_icon_wrapper = "layout-module--navbar_icon_wrapper--1dc08";
export var navbar_lang_switch_btn = "layout-module--navbar_lang_switch_btn--97675";
export var navbar_lang_switch_item = "layout-module--navbar_lang_switch_item--49dc3";
export var navbar_lang_switch_menu = "layout-module--navbar_lang_switch_menu--a2ff8";
export var navbar_lang_switch_toggle = "layout-module--navbar_lang_switch_toggle--8d409";
export var navbar_lang_switch_wrapper = "layout-module--navbar_lang_switch_wrapper--f6db3";
export var navbar_left = "layout-module--navbar_left--216d0";
export var navbar_logo = "layout-module--navbar_logo--8ba04";
export var navbar_menu_wrapper = "layout-module--navbar_menu_wrapper--81ddf";
export var navbar_right = "layout-module--navbar_right--6d156";
export var navbar_social_wrapper = "layout-module--navbar_social_wrapper--73fad";
export var navbar_wrapper = "layout-module--navbar_wrapper--984e6";